import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDateIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 23,
	viewBox: "0 0 20 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.66667 9.96428H4.44444V12.1786H6.66667V9.96428ZM11.1111 9.96428H8.88889V12.1786H11.1111V9.96428ZM15.5556 9.96428H13.3333V12.1786H15.5556V9.96428ZM17.7778 2.21429H16.6667V0H14.4444V2.21429H5.55556V0H3.33333V2.21429H2.22222C0.988889 2.21429 0.0111111 3.21071 0.0111111 4.42857L0 19.9286C0 21.1464 0.988889 22.1429 2.22222 22.1429H17.7778C19 22.1429 20 21.1464 20 19.9286V4.42857C20 3.21071 19 2.21429 17.7778 2.21429ZM17.7778 19.9286H2.22222V7.75H17.7778V19.9286Z",
		fill: "currentColor"
	})
});
export default SvgDateIcon;
